// extracted by mini-css-extract-plugin
export default {"listItem":"checkout_listItem__kXScb","btn_delete":"checkout_btn_delete__nxhXk"};